import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Wiadomosc } from '../../shared/models/wiadomosc.model';

@Injectable({
  providedIn: 'root',
})
export class WiadomoscService {

  constructor(
    private http: HttpClient,
  ) { }

  wyslij(wiadomosc: Wiadomosc) {
    return this.http.post<void>('/api/wiadomosc', wiadomosc);
  }
}
